module.exports = __webpack_public_path__ + "img/Stolpar_bild.d1c8ff99.jpg";